import request from '@/utils/request'

export const getdatalist = (params: any) =>
  request({
    url: '/expertlibrary/listPage',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const addExpert = (params: any) =>
  request({
    url: '/expertlibrary/save',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const updateExpert = (params: any) =>
  request({
    url: '/expertlibrary/update',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const deleteExpert = (params: any) =>
  request({
    url: '/expertlibrary/delete',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const uploadFile = (params: any) =>
  request({
    url: '/expertlibrary/uploadExpertLibrary',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getExpertInfo = (params: any) =>
  request({
    url: '/expertlibrary/getOne',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
